import MockAdapter from 'axios-mock-adapter';
import type { AxiosStatic } from 'axios';

export function useMock(axios: AxiosStatic) {
	const mock = new MockAdapter(axios, { delayResponse: 250 });

	mock.onAny().passThrough();
}
